var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLoboMobHeader(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 96,
    height: 40.861,
    viewBox: "0 0 96 40.861",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1092",
    "data-name": "Grupo 1092",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1056",
    "data-name": "Grupo 1056",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_207",
    "data-name": "Caminho 207",
    d: "M1.982,22.412,12.81,28.664a3.963,3.963,0,0,1,1.451,5.414l-3.917,6.783h21.3a3.964,3.964,0,0,0,3.433-1.982l8.67-15.016A3.964,3.964,0,0,0,42.3,18.449L31.472,12.2A3.964,3.964,0,0,1,30.02,6.782L33.936,0h-21.3A3.963,3.963,0,0,0,9.2,1.982L.531,17a3.964,3.964,0,0,0,1.451,5.414",
    transform: "translate(0)",
    fill: "#1c4584"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_208",
    "data-name": "Caminho 208",
    d: "M72.936,28.959a4.181,4.181,0,0,0,2.778,1.111c.852,0,1.365-.338,1.365-.892V29.15c0-.527-.324-.8-1.906-1.2-1.9-.486-3.134-1.013-3.134-2.892v-.027c0-1.717,1.378-2.851,3.31-2.851a5.252,5.252,0,0,1,3.447,1.15l-.958,1.659a4.674,4.674,0,0,0-2.515-.972c-.8,0-1.217.365-1.217.825v.027c0,.621.406.824,2.04,1.243,1.919.5,3,1.189,3,2.838v.027c0,1.879-1.458,2.933-3.473,2.933a6.986,6.986,0,0,1-3.71-1.264Z",
    transform: "translate(-20.096 -6.193)",
    fill: "#1c4584"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_209",
    "data-name": "Caminho 209",
    d: "M91,27.088v-.027a2.874,2.874,0,0,0-2.865-2.973A2.829,2.829,0,0,0,85.3,27.034v.027a2.873,2.873,0,0,0,2.865,2.972A2.829,2.829,0,0,0,91,27.088m-7.878,0v-.027a5.029,5.029,0,0,1,10.054-.027v.027a5.029,5.029,0,0,1-10.054.027",
    transform: "translate(-23.213 -6.191)",
    fill: "#1c4584"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_210",
    "data-name": "Caminho 210",
    d: "M100.536,24.284H97.657V22.365H105.5v1.919h-2.879v7.54h-2.081Z",
    transform: "translate(-27.271 -6.245)",
    fill: "#1c4584"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_211",
    "data-name": "Caminho 211",
    d: "M110.2,22.365h7.135v1.852h-5.068v1.919h4.459v1.852h-4.459v1.986H117.4v1.852h-7.2Z",
    transform: "translate(-30.773 -6.246)",
    fill: "#1c4584"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_212",
    "data-name": "Caminho 212",
    d: "M126.041,26.96c1.014,0,1.6-.541,1.6-1.338v-.027c0-.892-.622-1.351-1.635-1.351h-2.068V26.96Zm-4.188-4.595h4.324a3.771,3.771,0,0,1,2.756.959,2.972,2.972,0,0,1,.811,2.162v.027a2.937,2.937,0,0,1-2.027,2.932l2.311,3.379H127.6L125.568,28.8h-1.635v3.027h-2.08Z",
    transform: "translate(-34.028 -6.246)",
    fill: "#1c4584"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoboMobHeader);
export default __webpack_public_path__ + "static/media/lobo_mob_header.50782b373b72e98bd1fcaa959640aac1.svg";
export { ForwardRef as ReactComponent };